// extracted by mini-css-extract-plugin
export default {"searchfieldListaBtn":"Equipamentos_searchfieldListaBtn__sZjzX"};